<template>
  <basic-container v-loading="pageLoading">
    <!-- 基础信息 -->
    <avue-form
      ref="searchForm"
      v-model="searchForm"
      :option="searchFromOption"
      @reset-change="searchClear"
    >
      <template slot="menuForm">
        <el-button
          size="small"
          type="primary"
          @click="save(false)"
          v-if="searchForm.workStatus == 4"
        >
          保存
        </el-button>
        <el-button
          size="small"
          @click="submit"
          v-if="searchForm.workStatus == 4"
          >提交</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="updateStock"
          v-if="searchForm.workStatus == 5"
          >更新库存</el-button
        >
      </template>
    </avue-form>
    <!-- 表格信息 -->
    <avue-crud
      v-if="searchForm.workStatus == 4"
      ref="crud"
      :option="crudOption"
      :data="data"
      :page.sync="page"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
      <template slot="checkNum" slot-scope="{ row }">
         <el-form-item label="" :show-message="row.error" :error="row.error">
    <el-input
          v-model="row.checkNum"
          placeholder="请输入数量"
          @input="(v) => checkNumInput(v, row)"
        ></el-input>

  </el-form-item>
        <!-- <el-button size="small" @click="submit">提交</el-button> -->
        <!-- <el-input
          v-model="row.checkNum"
          placeholder="请输入数量"
          @input="(v) => checkNumInput(v, row)"
        ></el-input> -->
      </template>
      <template slot="description" slot-scope="{ row }">
        <!-- <el-button size="small" @click="submit">提交</el-button> -->
        <el-input
          v-model="row.description"
          placeholder="请输入备注"
          maxlength="300"
        ></el-input>
      </template>
    </avue-crud>
    <!-- 盈 -->
    <avue-crud
      v-if="searchForm.workStatus == 5 || searchForm.workStatus == 6"
      :data="surplusData"
      :option="surplusOption"
      :page.sync="surplusPage"
      @size-change="surplusSizeChange"
      @current-change="surplusCurrentChange"
      :cell-class-name="cellClassName"
      v-loading="surplusLoading"
    >
      <template slot="menuLeft">
        <div class="flex">
          <h4>盘盈物品信息</h4>
          <p>物品数量</p>
          <p>{{ surplusNumSum }}</p>
          <p>汇总金额</p>
          <p>{{ surplusAmtSum }}</p>
        </div>
      </template>
    </avue-crud>
    <!-- 亏 -->
    <avue-crud
      v-if="searchForm.workStatus == 5 || searchForm.workStatus == 6"
      :data="lossData"
      :option="lossOption"
      :page.sync="lossPage"
      @size-change="lossSizeChange"
      @current-change="lossCurrentChange"
      :cell-class-name="cellClassName"
      v-loading="lossLoading"
    >
      <template slot="menuLeft">
        <div class="flex">
          <h4>盘亏物品信息</h4>
          <p>物品数量</p>
          <p>{{ lossNumSum }}</p>
          <p>汇总金额</p>
          <p>{{ lossAmtSum }}</p>
        </div>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  checkDetail,
  checkConsumablePage,
  save,
  submit,
  losePage,
  profitPage,
  profitLoseSum,
  updateStock,
} from "@/api/crmedical/warehouse/check-task.js";
export default {
  props: {
    dicts: {
      type: Object,
      default: () => {
        return {
          projectList: [],
          warehouseList: [],
        };
      },
    },
    id: String,
  },
  computed: {
    searchFromOption() {
      return {
        size: "small",
        submitBtn: false,
        emptyBtn: false,
        menuSpan: 6,
        labelWidth: 100,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            span: 8,
            disabled: true,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.dicts.projectList,
          },
          {
            label: "仓库名称",
            prop: "warehouseId",
            type: "select",
            disabled: true,
            span: 8,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.dicts.warehouseList,
          },
          {
            label: "盘点批次单号",
            prop: "code",
            span: 8,
            disabled: true,
          },
          {
            label: "盘点开始时间",
            prop: "checkStartTime",
            span: 8,
            disabled: true,
          },
          {
            label: "盘点结束时间",
            prop: "checkEndTime",
            span: 8,
            disabled: true,
            display: !!this.searchForm.checkEndTime,
          },
        ],
      };
    },
    crudOption() {
      return {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        columnBtn: false,
        refreshBtn: false,
        menu: false,
        index: true,
        indexLabel: "序号",
        column: [
          {
            label: "物品",
            prop: "name",
          },
          {
            label: "编号",
            prop: "code",
          },
          {
            label: "规格",
            prop: "specification",
          },
          {
            label: "类型",
            prop: "typeName",
          },
          {
            label: "计量单位",
            prop: "measuringUnitName",
          },
          {
            label: "账面数量",
            prop: "stockNum",
          },
          {
            label: "单价",
            prop: "price",
          },
          {
            label: "账面金额",
            prop: "stockPrice",
          },
          {
            label: "盘点数量",
            prop: "checkNum",
            width: 100,
            slot: true,
          },
          {
            label: "盘点金额",
            prop: "checkPrice",
          },
          {
            label: "盈",
            prop: "surplus",
          },
          {
            label: "亏",
            prop: "loss",
          },
          {
            label: "备注",
            width: 150,
            prop: "description",
            slot: true,
          },
        ],
      };
    },
    surplusOption() {
      return {
        columnBtn: false,
        refreshBtn: false,
        saveBtn: false,
        updateBtn: false,
        cancelBtn: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        menu: false,
        index: true,
        indexLabel: "序号",
        // height:100,
        column: [
          {
            label: "物品",
            prop: "name",
          },
          {
            label: "编号",
            prop: "code",
          },
          {
            label: "类型",
            prop: "typeName",
          },

          {
            label: "计量单位",
            prop: "measuringUnitName",
          },
          {
            label: "品牌",
            prop: "brand",
          },
          {
            label: "规格",
            prop: "specification",
          },
          {
            label: "生产商",
            prop: "manufacturer",
          },
          {
            label: "入库单价",
            prop: "price",
          },
          {
            label: "库存数量",
            prop: "stockNum",
          },
          {
            label: "入库数量",
            prop: "num",
          },
          {
            label: "入库小计",
            prop: "subtotal",
          },
          {
            label: "备注",
            prop: "description",
            overHidden:true
          },
        ],
      };
    },
    lossOption() {
      return {
        columnBtn: false,
        refreshBtn: false,
        saveBtn: false,
        updateBtn: false,
        cancelBtn: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        menu: false,
        index: true,
        indexLabel: "序号",
        align: "center",
        menuAlign: "center",
        column: [
          {
            label: "物品",
            prop: "name",
          },
          {
            label: "编号",
            prop: "code",
          },
          {
            label: "类型",
            prop: "typeName",
          },
          {
            label: "计量单位",
            prop: "measuringUnitName",
          },
          {
            label: "品牌",
            prop: "brand",
          },
          {
            label: "规格",
            prop: "specification",
          },
          {
            label: "生产商",
            prop: "manufacturer",
          },
          {
            label: "出库单价",
            prop: "price",
          },
          {
            label: "库存数量",
            prop: "stockNum",
          },
          {
            label: "出库数量",
            prop: "num",
          },
          {
            label: "出库小计",
            prop: "subtotal",
          },
          {
            label: "备注",
            prop: "description",
            overHidden:true
          },
        ],
      };
    },
  },
  data() {
    return {
      pageLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data: [],
      surplusLoading: false,
      surplusPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      surplusData: [],
      surplusNumSum: 0,
      surplusAmtSum: "0.00",
      lossLoading: false,
      lossPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      lossData: [],
      lossNumSum: 0,
      lossAmtSum: "0.00",
      dialogLoading: false,
      searchForm: {
        projectId: "",
        warehouseId: "",
        code: "",
        workStatus: "",
      },
      addForm: {
        projectId: "",
        warehouseId: "",
        type: "",
        inboundStatus: "",
        inboundNo: "",
        enterUserName: "",
        enterTime: "",
        submitUserName: "",
        submitTime: "",
        cancelUserName: "",
        cancelTime: "",
      },
      addDialogVisible: false,
      csData: [],
      //展示表格列配置
      csColumns: [
        { label: "序号", prop: "", type: "index", width: 50 },
        { label: "物品", prop: "name" },
        { label: "编号", prop: "code" },
        { label: "类型", prop: "typeName" },
        { label: "品牌", prop: "brand" },
        { label: "规格", prop: "specification" },
        { label: "生产商", prop: "manufacturer" },
        { label: "计量单位", prop: "measuringUnitName" },
        { label: "数量", prop: "inboundNum" },
        { label: "单价", prop: "price" },
        { label: "小计", prop: "rowSum" },
        { label: "库存", prop: "stockNum" },
        {
          label: "剩余可数量领用",
          prop: "surplus",
          maxCheck: true,
          hide: true,
        },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    cellClassName() {
      console.log("1221212121==>", 1221212121);
      return "cell-max-height-100";
    },
    checkNumInput(val, row) {
      val = val.slice(0, 11);
      let temp = parseInt(val);
      row.checkNum = isNaN(temp) ? 0 : temp;
      this.calcRow(row);
    },
    calcRow(row) {
      if (!row.checkNum) {
        // row.checkNum = 0;
        row.checkPrice = 0;
        row.surplus = 0;
        row.loss = 0;
      } else {
        row.checkPrice = (row.checkNum * row.price).toFixed(2);
        let delta = row.checkPrice - row.stockPrice;
        if (delta > 0) {
          row.surplus = delta.toFixed(2);
          row.loss = 0;
        } else {
          row.loss = (-delta).toFixed(2);
          row.surplus = 0;
        }
      }
      return row;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.save(true);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.save(true);
    },
    async save(slience) {
      const postData = {
        warehouseId: this.searchForm.warehouseId,
        projectId: this.searchForm.projectId,
        id: this.searchForm.id,
        warehouseCheckConsumableList: this.data,
      };
      this.pageLoading = true;
      save(postData)
        .then(({ msg }) => {
          console.log("==>", slience);
          !slience && this.$message.success(msg);
          this.loadList();
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    submit() {
      const postData = {
        warehouseId: this.searchForm.warehouseId,
        projectId: this.searchForm.projectId,
        id: this.searchForm.id,
        warehouseCheckConsumableList: this.data,
      };
      //校验未输入的情况
      let errorFlag = false;
      this.data.forEach(element=>{
        if(!element.checkNum &&  element.checkNum!==0){
          element.error = '请输入一个自然数'
          errorFlag = true
        }else{
          element.error = ''
        }
      })
      this.data = Object.assign([],this.data)
      console.log('errorFlag==>',errorFlag);
      if(errorFlag) return;
      //提交
      this.$confirm("是否完成盘点并提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => submit(postData))
        .then((res) => {
          console.log("res123==>", res);
          this.$emit("taskSubmit", this.searchForm);
        })
        .catch((err) => {
          console.log("err==>", err);
          err == "cancel" && this.$message.info("已取消");
        });
    },
    updateStock() {
      this.pageLoading = true;
      updateStock({ checkId: this.searchForm.id })
        .then((res) => {
          this.pageLoading = false;
          console.log("res updateStock==>", res);
          if (res.success) {
            this.$message.success(res.msg);
            this.searchForm.workStatus = 6;
          }
        })
        .catch((err) => {
          this.pageLoading = false;
        });
    },
    async fetchData() {
      this.pageLoading = true;
      try {
        const { data } = await checkDetail({ id: this.id });
        this.searchForm = data;
        if (data.workStatus == 4) {
          this.loadList();
        } else if (data.workStatus == 5 || data.workStatus == 6) {
          this.loadList2();
        }
        console.log("resProjectList==>", data);
      } catch (err) {
        console.log("err==>", err);
      }
      this.pageLoading = false;
    },
    //盘点中的货品列表
    loadList() {
      const params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        checkId: this.searchForm.id,
        warehouseId: this.searchForm.warehouseId,
      };
      this.pageLoading = true;
      checkConsumablePage(params)
        .then(({ data: { records, total } }) => {
          this.pageLoading = false;
          this.page.total = total;
          records.forEach((element) => {
            element.stockPrice = (element.price * element.stockNum).toFixed(2);
            this.calcRow(element);
          });
          this.data = records;
        })
        .catch((err) => {
          this.pageLoading = false;
        });
    },
    //盘点完成后盈亏分开
    loadList2() {
      this.loadLosePage();
      this.loadWinPage();
      this.loadProfitLoseSum();
    },
    //亏
    lossSizeChange(pageSize) {
      this.lossPage.pageSize = pageSize;
      this.loadLosePage();
    },
    lossCurrentChange(currentPage) {
      this.lossPage.currentPage = currentPage;
      this.loadLosePage();
    },
    loadLosePage() {
      const params = {
        current: this.lossPage.currentPage,
        size: this.lossPage.pageSize,
        checkId: this.searchForm.id,
      };
      this.lossLoading = true;
      losePage(params)
        .then(({ data: { records, total } }) => {
          this.lossLoading = false;
          this.lossData = records;
          this.lossPage.total = total;
        })
        .catch((err) => {
          this.lossLoading = false;
          console.log("err==>", err);
        });
    },
    //盈
    surplusSizeChange(pageSize) {
      this.surplusPage.pageSize = pageSize;
      this.loadWinPage();
    },
    surplusCurrentChange(currentPage) {
      this.surplusPage.currentPage = currentPage;
      this.loadWinPage();
    },
    loadWinPage() {
      const params = {
        current: this.surplusPage.currentPage,
        size: this.surplusPage.pageSize,
        checkId: this.searchForm.id,
      };
      this.surplusLoading = true;
      profitPage(params)
        .then(({ data: { records, total } }) => {
          this.surplusLoading = false;
          this.surplusData = records;
          this.surplusPage.total = total;
        })
        .catch((err) => {
          console.log("err==>", err);
          this.surplusLoading = false;
        });
    },
    //盈亏汇总
    loadProfitLoseSum() {
      profitLoseSum({ checkId: this.searchForm.id }).then(({ data }) => {
        this.surplusNumSum = data.profitNum;
        this.surplusAmtSum = data.profitAmount;
        this.lossNumSum = data.loseNum;
        this.lossAmtSum = data.loseAmount;
      });
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex p {
  margin-left: 10px;
}
/* ::v-deep .cell-max-height-100 .cell {
  max-height: 100px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .cell-max-height-100 .el-form-item,
.el-form-item__content {
  width: 100%;
}
::v-deep .cell-max-height-100 span {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */
</style>